<pf-text bold>{{ changeText }}</pf-text>
<ul class="change-descriptions">
    @for (desc of changeDescriptions; track desc.field) {
        <li>{{ desc.description }}</li>
    }
</ul>
@if (!showTree) {
    <a class="show-tree-link" (click)="showTree = true">View Full Details</a>
}
@if (showTree) {
    <a class="show-tree-link" (click)="showTree = false">Hide Full Details</a>
    <platform-change-tree
        [autoExpand]="autoExpand"
        [customValueTransformer]="customValueTransformer"
        [entityName]="entityName"
        [entityChange]="entityChange"></platform-change-tree>
}
